// extracted by mini-css-extract-plugin
export default {"header":"app-header_header__y1qiv"};